import Comatize from '../components/Comatize'

export default function CURRENCY( value, symbol ) {
  if ( ! value ) return null

  return <>
    { symbol }<Comatize>{ value }</Comatize>
  </>
}
